module.exports = __webpack_public_path__ + "img/vanax-1.bac06bac.jpg";